import Vue from 'vue'
import App from './App.vue'
import 'vue-step-progress/dist/main.css';
import router from './router';
import store from './store';
import './main.css';
import VueTelInput from 'vue-tel-input';

Vue.use(VueTelInput)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
